const MONTH_NAMES = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

/**
 * `fmt_offset_activity_month_year` arrives as "July 2026". Parsed by name
 * rather than dayjs because that format needs the customParseFormat plugin,
 * which this project does not register.
 */
export const toYearMonth = (monthYear?: string | null) => {
  if (!monthYear) return null;
  const [monthName, year] = String(monthYear).trim().split(/\s+/);
  const monthIndex = MONTH_NAMES.indexOf(String(monthName).toLowerCase());
  if (monthIndex < 0 || !year) return null;
  return `${year}-${String(monthIndex + 1).padStart(2, "0")}`;
};

/** The offset lands on the 1st of the month, e.g. "July 2026" → "2026-07-01" */
export const toFirstOfMonth = (monthYear?: string | null) => {
  const yearMonth = toYearMonth(monthYear);
  return yearMonth ? `${yearMonth}-01` : (monthYear ?? null);
};
